import React from 'react';
import Navigation from '../Navigation';
import Footer from '../Footer';

const Layout = ({ children, currentPage }) => {
  return (
    <div className="layout">
      <Navigation currentPage={currentPage} />
      <main>{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
